import { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import {
  setMultiSubcategoryPurchaseLimitsFlag,
  setConfigurablePurchaseLimitsFlag,
  MULTI_SUBCATEGORY_PURCHASE_LIMITS_FLAG,
  CONFIGURABLE_PURCHASE_LIMITS_FLAG,
} from 'state/purchase-limits-flag';

export default function usePurchaseLimitsFlagsController(): void {
  const flags = useFlags();
  const rawMultiSubcategoryFlagValue = flags[MULTI_SUBCATEGORY_PURCHASE_LIMITS_FLAG];
  const rawConfigurablePurchaseLimitsFlagValue = flags[CONFIGURABLE_PURCHASE_LIMITS_FLAG];

  useEffect(() => {
    setMultiSubcategoryPurchaseLimitsFlag(rawMultiSubcategoryFlagValue);
  }, [rawMultiSubcategoryFlagValue]);

  useEffect(() => {
    setConfigurablePurchaseLimitsFlag(rawConfigurablePurchaseLimitsFlagValue);
  }, [rawConfigurablePurchaseLimitsFlagValue]);
}
